export default {
  productList: 'Manage Products',
  listingId: 'Listing ID',
  SKU_productId: 'SKU ID',
  title: 'Title',
  showCountry: '展示国家',
  baseStation: '基站',
  expand: '扩展',
  options: '选项',
  expanded: '已扩展',
  unExpanded: '未扩展',
  all: 'All',
  category: 'Category',
  addTime: 'Added Date',
  thisMonth: 'This Month',
  today: 'Today',
  online: 'Online Payment',
  offline: 'Pay on Delivery',
  prePay: 'PrePay',
  all2: 'All',
  resetFilter: 'Reset Filter', //
  setPaymentMethod: '批量设置商品所支持的支付方式',
  supportOnlinePay1: '商品所在仓库默认都支持Online Pay，系统对于商品所支持的支付方式由 商品本身的支付方式 + 所在仓库所支持的支付方式 合并产生，所以对商品设置时一般无需额外再设置支持Online Pay。同时，由于批量操作针对的是Listing，那么当设置后Listing下所有的SKU都支持所设置的支付方式。',
  supportOnlinePay2: '由于批量选择的商品可能不在同一个仓库，所以在批量设置中暂时无法展示每一个商品当前所支持的支付方式。',
  supportOnlinePay3: ' 您将设置所选中的这些商品支付以下支付方式(支持请打勾)',
  COD: 'COD',
  selectAll: 'Select all',
  setActive: 'Active',
  setInactive: 'Inactive',
  applyActive: 'Apply for activation',
  applyActiveDisabledTitle: 'Not available to apply for activation',
  violationCountTip: 'This product has been removed for violations {0} time(s)',
  coolDownRemainTip: '{0} day(s) left in the waiting period',
  applyAvailableTip: 'Available to apply after {0}',
  qcCoolingOffTag: 'Cooling-off period: {0} day(s) left before you can apply for activation',
  qcRelistableTag: 'Cooling-off period ended, ready to apply for activation',
  setPay: 'Payment Method',
  exportExcel: 'Export Products',
  chooseCategory: 'Choose Category',
  cat: 'Cat#',
  priceMin: 'Price Min',
  priceMax: 'Price Max',
  skuCount: 'Sku Count',
  status: 'Status',
  weight: 'Weight(g)',
  operation: 'Operation',
  leastPay: '请至少设置 一个支付方式！',
  confirmPaymethod1: 'Do you confirm that you ',
  confirmPaymethod2: 'do NOT support ',
  confirmPaymethod3: ' as payment methods？',
  confirmPaymethod4: 'do support ',
  batchInactiveGoods: 'Are you sure to inactive the selected {0} products?',
  batchActiveGoods: 'Are you sure to active the selected {0} products?',
  whetherDelete: 'Are you sure to remove this product?',
  batchOperation: 'Batch Operation',
  // S349
  categoryStore: 'Category(Store) ',
  storeCategory: 'Store Category',
  okText: 'OK',
  moveSure: 'Are you sure to move these products to category',
  // A total of @@ products are currently selected, belonging to @@ in-store categories
  categoriesTotal1: 'A total of',
  categoriesTotal2: 'products are currently selected',
  categoriesTotal3: 'belonging to',
  categoriesTotal4: 'in-store categories',
  batchPrice: 'Batch Price Modify',
  limitPriceChange: 'There are only 2 changes per day, and each modification takes tens of seconds to tens of minutes.',
  reminderOfTimesLimit: 'You can\'t modify f until tomorrow because you\'ve already modified 2 times today.',
  exportProducts: 'Export products',
  stepOne: 'Step 1',
  stepTwo: 'Step 2',
  // allProducts: 'All products',
  // saleProducts: 'On sale products',
  // exportTemplate: 'Export Template ',
  UploadFiles: 'Upload files',
  selectCountry: 'Please select a country first',
  SelectFiles: 'Select files',
  batchPriceCancel: 'Cancel',
  batchPriceSubmit: 'Submit',
  violationStatus: 'violation status',
  normal: 'normal',
  violation: 'violation',
  infoScore: 'Info. Score',
  thisProductScore: 'This product information quality score is {0}',
  thereRecommended: 'There are {0} optimizations recommended for you:',
  scoreTitleOptimize: 'Improve product title length',
  scoreCarouselOptimize: 'Upload more product carousel main images',
  scoreVideoOptimize: 'Upload the main video of the product',
  scoreAttributeOptimize: 'Improve product attribute information',
  scoreDetailOptimize: 'Improve or enrich the copywriting and pictures of detailed descriptions',
  scoreWhiteOptimize: 'Upload the white background image of the product',
  optimizeNow: 'Optimize Now',
  active: 'Active',
  inactive: 'Inactive',
  qcReject: 'QC Reject',
  qcWarning: 'QC Warning',
  qcLocked: 'QC Locked',
  pendingQC: 'Pending QC',
  removed: 'Removed',
  unexpanded: 'Unexpanded',
  supportedShippingType: 'Supported Shipping Method',
  agentProduct: 'Agent Product',
  vendorProductID: 'Vendor Product ID',
  countrySite: 'Country Site',
  expandAndCollapse: 'Expand /Collapse',
  productName: 'Product Name',
  priceRange: 'Price Range',
  fbkStock: 'FBK',
  fbk: 'FBK',
  ds: 'DS',
  gs: 'GS',
  yes: 'Yes',
  no: 'No',
  pleaseSelect: 'Please select',
  basicSite: 'Basic Site',
  creationDate: 'Creation Date',
  r30Sold: 'R30 Sold',
  inventory: 'Inventory',
  removeDate: 'Remove Date',
  skus: 'SKUs',
  latestViolationReason: 'Latest Violation Reason',
  applyActivation: 'Apply for activation',
  remove: 'Remove',
  max: 'Max',
  min: 'Min',
  brand: 'Brand',
  addProduct: 'Add Product',
  skuSymbol: 'SKU#',
  skuImage: 'SKU Image',
  variant: 'Variant',
  marketReferencePrice: 'Market Reference Price',
  sellingPrice: 'Selling Price',
  collapse: 'Collapse',
  expandIcon: 'Expand',
  multiValue: 'multi-value supported',
  support: 'Support',
  noSupport: 'Do not support',
  paymentMethodNoteOne: 'Note: This setting will be applied to the product-level only for the selected ',
  paymentMethodNoteTwo: ' products.',
  confirm: 'Confirm',
  moveTheSelect: 'Move the selected {0} products to',
  removeNote: 'Are you sure to remove selected {0} products?',
  applyActivationNote1: 'Are you sure to apply activation for selected {0} products?',
  activatedForSale: 'Activated, available for sale',
  notActivatedForSale: 'Inactivated, not available for sale',
  pendingPlatformReview: 'Pending platform review, not available for sale',
  inactivatedPlatformViolation: 'Inactivated due to platform violation, not available for sale, but can apply for activation',
  qcWarningTip: 'Alert for potential policy violation. Item remains purchasable. Optimize listing to avoid breach.',
  lockedTip: 'Inactivated due to platform violation, not available for sale. For reactivation, please contact platform seller service team',
  removedTip: 'Removed, not available for sale',
  unexpandedTip: 'Products without a set selling price on the current country site, not available for sale. It will automatically be activated for sale once the price is set',
  duplicate: 'Duplicate',
  nonFbk: 'Non-FBK',
  nonFbkAvail: 'Non-FBK(Avail)',
  fbkaAvail: 'FBK(Avail)',
  fold: 'Fold',
  more: 'More',
  totalAvailableInv: 'Total Available Inventory',
  createDate: 'Create Date',
  updateDate: 'Update Date',
  supportedFulfillType: 'Supported Fulfill Type',
  newProduct: 'New Product',
  productInfo: 'Product Info',
  price: 'Price',
  optimizedNum: '{0} places to be optimized',
  delete: 'Delete',
  violationReason: 'Violation Reason',
  viewWarningReason: 'Warning Reason',
  edit: 'Edit',
  rating: 'Rating',
  scoreTip: 'The product information score ranges from 0 to 100, evaluating the completeness of information provided. Higher scores indicate better quality.',
  vendorProductId: 'Vendor Product ID',
  clearFilter: 'Clear filter',
  batchApply: 'Batch Apply',
  nonFbkInventory: 'Non-FBK Available Inventor',
  editPrice: 'Edit Price',
  editInventory: 'Edit Inventory',
  totalInventory: 'Total Inventory',
  lockedInventory: 'Locked Inventory',
  availableInventory: 'Available Inventory',
  lockedInventoryTip: 'This includes the number of items in active orders or committed to promotions (like flash sales). When an order is canceled or a promotion ends, the unconsumed items will be released as available inventory.',
  availableInventoryTip: `Unlocked inventory can be used for regular sales. When set to 0, the product becomes immediately unavailable for non-promotional sales, but previously locked inventory may become available again. If you are out of stock in real, it's best to inactive the specific variants.`,
  statusTip: 'Indicates the sale status of the variant.',
  mustBeGreaterSelling: 'Must be greater than selling price',
  mustBeLessMarket: 'Must be less than market reference price',
  notEmpty: 'Can not be empty',
  mustGreaterZero: 'Must be greater than 0',
  conNotLessZero: 'Can not be less than 0',
  mustInteger: 'Must be an integer',
  inputFilterPlaceholder: 'Variant Name /SKU ID /Vendor Product ID',
  downloadTemplate: 'Download template',
  someVariantsPriceClear: 'Some variants have non-compliant price settings. Please review after clearing the filter conditions.',
  someInventoryClear: 'Some variants have non-compliant inventory settings. Please review after clearing the filter conditions.',
  allProductExcept: 'All products except for those deleted or unexpanded.',
  deleted: 'Deleted',
  pleaseSelectBrand: 'Choose Brand',
  handlerSuccess: 'Success',
  alrightIamAware: 'Alright, I am aware',
  back: 'Back',
  paymentMethodNote: 'Note: This setting will be applied to the product-level only for the selected {0} products',
  supportFbk: 'Support FBK',
  noSupportFbk: 'Not Support FBK',
  successfullyCopied: 'Successfully Copied',
  thisActiveGoods: 'Are you sure to active this product?',
  thisInactiveGoods: 'Are you sure to inactive this product?',
  applyActiveOnly: 'Are you sure to apply activation for this product?',
  deleteGoodsOnly: 'Are you sure to delete this product?',
  quality: 'Quality',
  goodsQualitySetting: 'Product Warranty Settings',
  listingNo: 'Listing #',
  noQuestions: '7D Return (no reason)',
  noQuestionsSetCategory: 'This policy is pre-set by the platform based on product category and cannot be modified by sellers.',
  noQuestionsInfoPath: `Platform 7-Day No-Reason Return Policy and Requirements >>`,
  addedQuestions: 'Added Warranty Items',
  qualityDeadline: 'Warranty Support',
  returnRefundDeadline: 'Return & Refund',
  exchangeDeadline: 'Exchange',
  qualityDeadlineTips: 'Full Maintenance Support. Period for free repair services for quality issues. (Repair only, low service tier)',
  returnRefundDeadlineTips: 'Return for Refund. Period allowed to return goods for a full refund due to quality issues. (High service tier)',
  exchangeDeadlineTips: 'Exchange for New. Period allowed to exchange the item for a new one due to quality issues. (Medium service tier)',
  addQuestionsItem: 'Add Warranty Item',
  save: 'Save',
  update: 'Update',
  add: 'Add New',
  confirmAddQualityItem: 'Are you sure you want to add this warranty entry?',
  pleaseEnter: 'Please enter',
  warrantyPeriodBelowCategory: 'This period is below the category requirement.',
  warrantyCategoryMinStandardBanner: `Each category has mandatory minimum limits for (return（{0} days）, exchange ({1} days), warranty ({2} days) and {3}-day no-reason rules. Your settings do not meet the specified minimum standards. Please revise and resubmit.`,
  batchWarrantyCategoryMinStandardTip: `Specific minimum durations for return, exchange, warranty and 7-day no-reason are required for each category. Part of the selected products do not meet the mandatory minimum rules. Please adjust and submit again.`,
  warrantyPrefillHint: `Italic-grey text is the default pre-fill value configured by the platform category where the current-day item belongs.`,
  cannotAddDuplicate: 'A warranty item of the same type has already been added and cannot be added again.',
  cancel: 'Cancel',
  warrantySetting: 'Warranty Setting',
  successfully: 'successfully',
  doYouRemoveThis: 'Do you wish to remove this warranty item?',
  warningReasonTitle: 'Reasons for the warning:',
  customWarrantyOverride: 'Your Custom Warranty Settings override Platform Defaults.',
  platformDefaultsApply: 'If no custom items are added, Platform Category Requirements will apply automatically.',
  batchSetWarranty: 'Batch Set Warranty',
  confirmSettingListings: 'The setting will effectived for {0} listings ({1} SKUs included)',
  batchSetWarrantyInfo: '{0} Listing Selected ( {1} SKUs Included)',
  complaintWarnInfringementType: 'Trademark Infringement',
  complaintWarnBody1: 'This product has been reported by users for infringement, specific reason for infringement: ',
  complaintWarnBody2: '. If you have any questions, please file an appeal within 7 days. ',
  complaintWarnAppealLink: 'Click here to file an appeal>>>',
  appealDialogTitle: 'Product Violation Appeal',
  appealBanner: 'Only one appeal per product is allowed. Please ensure all necessary documents are provided!',
  appealTypeLabel: 'Appeal Type *',
  appealBasicLabel: 'Basic Information *',
  appealBasicUploadTip: 'File size under 10MB, or up to 3 images.',
  appealSupplementLabel: 'Supplementary materials (optional)',
  appealReasonLabel: 'Additional notes (optional)',
  appealSubmit: 'Submit',
  appealSubmitSuccess: 'Appeal submitted successfully',
  appealSubmitSuccessTitle: 'Product appeal submitted successfully!',
  appealSubmitSuccessDesc: 'Please wait for review by the platform administrator. If approved, the product will be automatically activated. If rejected, the reason will be displayed on this page.',
  appealRejectedTitle: 'Product appeal rejected!',
  appealRejectedReasonLabel: 'Reason: ',
  appealRejectedDetailLabel: 'Details: ',
  appealRejectionReasonUnknown: 'Other reason',
  appealResultCloseBtn: 'Closed'
}
